"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'chromecast';
exports.SET_DEVICES = exports.namespace + "/SET_DEVICES";
exports.SET_IS_CONNECTED = exports.namespace + "/SET_IS_CONNECTED";
exports.SET_IS_READY_TO_CAST = exports.namespace + "/SET_IS_READY_TO_CAST";
exports.SET_IS_ATTEMPTING_TO_CAST = exports.namespace + "/SET_IS_ATTEMPTING_TO_CAST";
exports.SET_IS_DEVICE_MODAL_OPEN = exports.namespace + "/SET_IS_DEVICE_MODAL_OPEN";
exports.SET_CONNECTED_DEVICE = exports.namespace + "/SET_CONNECTED_DEVICE";
exports.SET_CASTING_IS_LOADING = exports.namespace + "/SET_CASTING_IS_LOADING";
exports.SET_CASTING_DATA = exports.namespace + "/SET_CASTING_DATA";
exports.CONNECTING_ERROR = exports.namespace + "/CONNECTING_ERROR";
exports.CASTING_ERROR = exports.namespace + "/CASTING_ERROR";
exports.SET_IS_CONNECTING = exports.namespace + "/SET_IS_CONNECTING";
exports.SET_IS_PLAYER_EXPANDED = exports.namespace + "/SET_IS_PLAYER_EXPANDED";
exports.SET_IS_PLAYER_SEASONS_SELECTOR_VISIBLE = exports.namespace + "/SET_IS_PLAYER_SEASONS_SELECTOR_VISIBLE";
exports.SET_VOLUME_LEVEL = exports.namespace + "/SET_VOLUME_LEVEL";
//# sourceMappingURL=constants.js.map